import { Component } from '@angular/core';

@Component({
    selector: 'astrea-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent {

  currentYear!: number;

  constructor() {
    this.currentYear = new Date().getFullYear();
  }

}
